import type { FaireProductEntity } from "../../entity_types/product";

export const p_868dqutqmx: FaireProductEntity = {
  token: "p_868dqutqmx",
  type: "product",
  name: "Conditioner Bar for Volumizing and Thickening",
  brandToken: "b_4iyz6j79hv",
  brandName: "The Earthling Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/2a711ec37f969c847e7ee76d269b2f9887a453c7c3a2d2d04f7cfb7fc066d514.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d9fdd0e44078224b01e47b1751a42942223023f57c217ea2501ec3b221afc443.jpeg",
    "https://cdn.faire.com/fastly/e217b8fc0f5903c053b2e165263960796d9a14608e4c38d5289ec538d70d1fcc.jpeg",
    "https://cdn.faire.com/fastly/81567e1d57c1cd88626959ac014432640221d47311a157acca7b2078bcaed3ba.jpeg",
    "https://cdn.faire.com/fastly/32f5563f22c06e132ef3ced19ad09d2a4c7e4c52b80e6de40ab29a952efecef0.jpeg",
    "https://cdn.faire.com/fastly/ec3fe1990c7abf835927f191905c97745da674324a7652d3fe63be77e8acdee0.jpeg",
    "https://cdn.faire.com/fastly/a8d2a6d3ea80160933bf13b3399dbab0060a0ab169bbfd4bf367acf6f41a9ad3.jpeg",
    "https://cdn.faire.com/fastly/dc5724cdbd9eab7a95de14396bd2445b4a39867f3bb33d2f4181ebf12e199331.jpeg",
    "https://cdn.faire.com/fastly/e03b5c799ece3f34ce009e42b02e384d6febbc64b8a2829e6ae3196b25e5572d.jpeg",
    "https://cdn.faire.com/fastly/3dacafb7085eef3ee82c9289aeb4ca982128206eb02f992e75f2de7f5ce26b47.jpeg",
    "https://cdn.faire.com/fastly/e2695449a986fca5a218fca9c013312b0db87418aff907ec1b6f36f247be9333.png",
    "https://cdn.faire.com/fastly/94746c763bb203368eb9b3d40158c3ad17934cbfcd6aaca2ef2cfc5059e98e46.png",
    "https://cdn.faire.com/fastly/23d837a2881961b7b28f9cf1a99004ab21ccaeb5e134cd23c9a3600718388c3f.png",
    "https://cdn.faire.com/fastly/fa26f07d9e88403b4a6baf8de1ff33077b07b09bc59835a5a526c01d93eed4e8.png",
    "https://cdn.faire.com/fastly/5f7050e4c3f14b5e1319458050c5582d8854205e2b1960e515cf4800f383d4c5.png",
    "https://cdn.faire.com/fastly/dcd75f80eb625a93f6bf75ea54fd57f8a2dc66c6ec572bce10c24deab4f84f2b.png",
    "https://cdn.faire.com/fastly/4559f08ce1b652d13c65c727f96f457bf6f94ee1f879c2cb75c342b63464076f.png",
    "https://cdn.faire.com/fastly/6c4fad8f4c8c12e8731fb47ec59a818102ff4dc27770e37af87bdd6e525a5128.jpeg",
  ],
  priceDollars: 11.07,
  description:
    "Unlock the best hair of your life with high-quality, intentional ingredients that nourish, protect, and enhance your natural shine.\n\nPrized for its effective detangling abilities and silky condition, our plastic-free Conditioner Bar penetrates the hair shaft with hydration and moisture, all while staying gentle on your skin and scalp. Made with a balanced formula of nourishing, naturally derived ingredients that restore shine, reduce frizz and breakage, and improve overall hair health – keeping your hair soft and strong, all day long.\n\nOur bars create a creamy, silky conditioner texture when met with water. They’re perfect for daily use and can double as a leave-in conditioner as well. You’ll fall in love with your healthiest, smoothest hair yet.\n\nA great gift for Mother's Day, sustainability and travel, and getting hair ready for summer! ",
  tags: [],
  msrpDollars: 22.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:24.254Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
